import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

import { EditarButton, FiltroInput, FormOutlined } from './styles';

const getColumnSearchProps = () => {
  let searchInput;
  return {
    filterDropdown: filter => (
      <div style={{ padding: 8 }}>
        <FiltroInput
          aria-label="inputSearch"
          ref={node => {
            searchInput = node;
          }}
          value={filter?.selectedKeys?.length ? filter.selectedKeys[0] : ''}
          onChange={e =>
            filter.setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={filter.confirm}
        />
        <Button
          type="primary"
          onClick={filter.confirm}
          icon={<SearchOutlined />}
          style={{ marginRight: 5 }}
        >
          Pesquisar
        </Button>
        <Button className="btn-limpar" onClick={filter.clearFilters}>
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined className={filtered && 'color-search-outlined'} />
    ),
    onFilterDropdownVisibleChange: visible => {
      visible && setTimeout(() => searchInput.select());
    },
  };
};

export const getColumns = (handleEditClient, filters) => {
  const columns = [
    {
      title: 'Nome do cliente',
      dataIndex: 'razao_social',
      key: 'razao_social',
      width: '65%',
      filteredValue: filters.razao_social,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'CNPJ',
      dataIndex: 'cnpj_resumido',
      key: 'cnpj_resumido',
      width: '30%',
      filteredValue: filters.cnpj_resumido,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'Ações',
      width: '5%',
      render: (text, record) => (
        <EditarButton type="link" onClick={() => handleEditClient(record)}>
          <FormOutlined />
        </EditarButton>
      ),
    },
  ];

  return columns;
};
